module.exports = {"150304002":"三道坎街道","150304003":"五虎山街道","150304008":"新达街道","150304009":"巴音赛街道","150304010":"梁家沟街道","150304011":"苏海图街道","150304012":"滨海街道","150304101":"乌兰淖尔镇","150304400":"乌达经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150304.json
// module id = 369
// module chunks = 0